import type { SettingsSearchRow } from "../settings-search-types";

/** Anchor ids for the Preferences page's rows — imported by BOTH the page
 *  (to place `SettingsHighlightTarget`s) and the search catalog, so a jump
 *  can never name a row the page doesn't mark. */
export const PREFERENCES_ANCHORS = {
  defaultView: "default-view",
  displayNames: "display-names",
  firstDayOfWeek: "first-day-of-week",
  timeFormat: "time-format",
  toastPosition: "toast-position",
  pointerCursors: "pointer-cursors",
  railCountDot: "rail-count-dot",
  showEmptyProperties: "show-empty-properties",
  reduceMotion: "reduce-motion",
  autoAssignSelf: "auto-assign-self",
  autoAssignTeam: "auto-assign-team",
} as const;

export const PREFERENCES_SEARCH_ROWS: readonly SettingsSearchRow[] = [
  {
    anchor: PREFERENCES_ANCHORS.defaultView,
    label: "Default view",
    keywords: ["landing", "home", "start"],
  },
  {
    anchor: PREFERENCES_ANCHORS.displayNames,
    label: "Display names",
    keywords: ["first name", "full name"],
  },
  {
    anchor: PREFERENCES_ANCHORS.firstDayOfWeek,
    label: "First day of the week",
    keywords: ["monday", "sunday", "calendar"],
  },
  {
    anchor: PREFERENCES_ANCHORS.timeFormat,
    label: "Time format",
    keywords: ["24-hour", "12-hour", "military time", "am pm", "clock"],
  },
  {
    anchor: PREFERENCES_ANCHORS.toastPosition,
    label: "Toast position",
    keywords: ["notification position", "corner"],
  },
  {
    anchor: PREFERENCES_ANCHORS.pointerCursors,
    label: "Use pointer cursors",
    keywords: ["hand cursor", "mouse"],
  },
  {
    anchor: PREFERENCES_ANCHORS.railCountDot,
    label: "Show unread count as a dot",
    keywords: ["badge", "inbox", "notification", "rail", "number"],
  },
  {
    anchor: PREFERENCES_ANCHORS.showEmptyProperties,
    label: "Show empty properties",
    keywords: ["more", "fold", "collapse", "blank fields", "drawer", "properties"],
  },
  {
    anchor: PREFERENCES_ANCHORS.reduceMotion,
    label: "Reduce motion",
    keywords: ["animation", "accessibility"],
  },
  {
    anchor: PREFERENCES_ANCHORS.autoAssignSelf,
    label: "Auto-assign to self",
    keywords: ["assignee", "assignment"],
  },
  {
    anchor: PREFERENCES_ANCHORS.autoAssignTeam,
    label: "Auto-assign my team",
    keywords: ["assigned team", "default team", "assignment"],
  },
];
